/**
 * Navigation utility functions
 */

/**
 * Get the page title based on the current pathname
 * @param {string} pathname - The current pathname from useLocation
 * @param {string} roleName - Optional role name for job detail pages
 * @returns {string|null} The page title or null if no title should be shown
 */
export const getPageTitle = (pathname, roleName = null) => {
    if (pathname === '/jobs') {
        return 'Roles';
    } else if (pathname.startsWith('/jobs/') && pathname !== '/jobs/new') {
        // Use the roleName prop that's passed from JobDetails component
        return roleName || 'Job Details';
    } else if (pathname === '/jobs/new') {
        return 'Create New Role';
    } else if (pathname === '/applicant-search') {
        return 'Applicant Search';
    } else if (pathname === '/settings/profile') {
        return 'Profile Settings';
    } else if (pathname === '/settings/company') {
        return 'Company Settings';
    } else if (pathname === '/subscription') {
        return 'Subscription';
    } else if (pathname === '/assessment-form') {
        return 'Evaluation Form';
    } else if (pathname.startsWith('/interview/')) {
        return 'Interview';
    } else if (pathname === '/onboarding/company') {
        return 'Company Onboarding';
    }

    return null; // Don't show title for other pages
};
